import { server } from '../engine/server'
import { modal } from '../utilities/modal'
import { user } from './user';

var Billing = Class.create({
  	initialize: function() {
	},
    createProfile: function(data, callback) {
		// prepare our data to be sent
		var url = "billing/user";
		var params = data;
		// #  Send to server object for processing
		var data = server.getData(url,params, true, "POST");
		// #  Listen to our data
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
        });
    },
    getProfile: function(callback, async = true) {
		var url = "billing/user";
		var data = server.getData(url, null, async, "GET");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
            if (e.status == 404) {
                callback(false);
            } else  if (e.status == 401) {
                callback(false);
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
    },
    updateProfile: function(data, callback) {
		var url = "billing/user";
		var data = server.getData(url, data, true, "PUT");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
            if (e.status == 404) {
                callback(false);
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
	},
	getInstitutions: function(callback) {
		var url = "billing/institutions";
		var data = server.getData(url, null, true, "GET");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
            if (e.status == 404) {
                callback(false);
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
	},
	authInstitution: function(data, callback) {
		var url = "billing/institution/auth";
		var data = server.getData(url, data, true, "POST");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
        });
	},
	addBankAccount: function(bankAccount, callback) {
		var url = "billing/bank/add";
		var data = server.getData(url, bankAccount, true, "POST");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
        });
	},
	getBankAccount: function(id, callback) {
		var url = "billing/bank/account";
		var params = {
			id: id
		};
		var data = server.getData(url, params, true, "GET");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
        });
	},
	deleteBankAccount: function(id, callback) {
		var url = "billing/bank/account/" + id;
		var data = server.getData(url, null, true, "DELETE");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
        });
	},
	updateBankAccount: function(bank, callback) {
		var url = "billing/bank/account";
		var data = server.getData(url, bank, true, "PUT");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
	},
	processMFA: function(mfa, callback) {
		var url = "billing/institution/auth/security";
		var data = server.getData(url, mfa, true, "POST");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
	},
	verifyBank: function(data, callback) {
		var url = "billing/bank/verify";
		var data = server.getData(url, data, true, "POST");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
	},
	voidTransaction: function(data, callback) {
		var url = "billing/cancel/transaction/" + data.transaction_id;
		var data = server.getData(url, data, true, "DELETE");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
	},
	voidPayoutTransaction: function(data, callback) {
		var url = "billing/cancel/payout/transaction/" + data.transaction_id;
		var data = server.getData(url, data, true, "DELETE");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
	},
});

export let billing = new Billing();


// WEBPACK FOOTER //
// app/core/controllers/Billing.js